/* ===========================================================
   SEO — constantes do site e helpers de URL.
   Fonte única do domínio canônico (www) usado por <head>, JSON-LD e
   pelo gerador de sitemap. Trocar o host aqui propaga para tudo.
   =========================================================== */

export const SITE = {
  /** Host canônico — bate com o canonical do index.html e o www→apex do deploy. */
  base: "https://www.lucraamais.com.br",
  nome: "Lucraa+",
  org: "Digitalizee",
  twitter: "@lucraamais",
} as const;

/** Caminho de rota → URL canônica absoluta (sem barra final, exceto a raiz). */
export function urlCanonica(path: string): string {
  if (path === "/" || path === "") return SITE.base + "/";
  return SITE.base + "/" + path.replace(/^\/+/, "").replace(/\/+$/, "");
}

/** Monta o <title> padrão das páginas de conteúdo: "<algo> | Lucraa+". */
export function titulo(s: string): string {
  return `${s} | ${SITE.nome}`;
}
